var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ueditor", attrs: { id: _vm.ueditorBoxId } },
    [
      _c(
        "el-upload",
        {
          staticStyle: { display: "none" },
          attrs: {
            name: "file",
            "before-upload": _vm.beforeUpload,
            "on-exceed": _vm.handleExceed,
            multiple: true,
            "on-progress": _vm.uploadProgress,
            limit: _vm.limit,
            action: _vm.action,
            headers: _vm.headers,
            accept: _vm.accept,
            "show-file-list": false,
            "on-success": _vm.uploadSuccess,
            "on-error": _vm.uploadError
          }
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                icon: "el-icon-upload2",
                id: _vm.fileUploadId
              }
            },
            [_vm._v("导入")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "ueditor-container",
        attrs: { id: _vm.ueditorId }
      }),
      _vm._v(" "),
      _vm.editorUpLoading
        ? _c("div", { staticClass: "ue-loading" }, [
            _vm._v("已上传" + _vm._s(_vm._f("percent")(_vm.uploadProcess, 1)))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f76e8c66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f76e8c66","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UeEditor.vue
// module id = 546
// module chunks = 14